const getMemberCount = (team) => {
  const memberCount = team?.team?.memberTeams?.length;
  const initialQuantity = team?.team?.initialQuantity;

  return memberCount > initialQuantity ? memberCount : initialQuantity;
};

export default getMemberCount;
